import _sfc_main from './PortfolioSelector.vue2.js';
import normalizeComponent from '../../_virtual/_plugin-vue2_normalizer.js';

var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "fds-widget fds-ui-input fds-ui-input--select fds-portfolio-selector", class: { "fds-ui-loading": _setup.isLoadingStoreData } }, [_vm._t("root", function() {
    return [_vm._t("label", function() {
      return [_c("label", { staticClass: "fds-ui-input__label", attrs: { "for": _setup.selectorId } }, [_vm._v(_vm._s(_setup.translate("portfolioSelector.label")))])];
    }, null, { localizationSupport: _setup.localizationSupport, storeModule: _setup.storeModule, selectorId: _setup.selectorId, label: "portfolioSelector.label" }), _vm._t("input", function() {
      return [_c("div", { staticClass: "fds-ui-input__field" }, [_c("select", { staticClass: "fds-portfolio-selector__select fds-ui-select", attrs: { "id": _setup.selectorId, "name": "fds-portfolio-selector" }, domProps: { "value": _vm.value }, on: { "change": _setup.onPortfolioChange } }, [_vm._l(_setup.portfolios, function(portfolio, index) {
        return [_c("option", { key: `fds-porfolio-selector-option-${index}`, domProps: { "value": portfolio.id } }, [_vm._t("input:option", function() {
          return [_c("span", [_vm._v(_vm._s(_setup.textFormat(portfolio.name)))])];
        }, null, { value: _vm.value, portfolio, index, localizationSupport: _setup.localizationSupport, storeModule: _setup.storeModule, onPortfolioChange: _setup.onPortfolioChange, label: portfolio.name })], 2)];
      })], 2)])];
    }, null, { localizationSupport: _setup.localizationSupport, storeModule: _setup.storeModule, onPortfolioChange: _setup.onPortfolioChange, selectorId: _setup.selectorId, value: _vm.value })];
  }, null, { localizationSupport: _setup.localizationSupport, storeModule: _setup.storeModule, selectorId: _setup.selectorId, onPortfolioChange: _setup.onPortfolioChange })], 2);
};
var _sfc_staticRenderFns = [];
_sfc_render._withStripped = true;
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
__component__.options.__file = "/home/ubuntu/actions-runner/_work/library/library/packages/library/src/components/portfolio-selector/PortfolioSelector.vue";
var PortfolioSelector = __component__.exports;

export { PortfolioSelector as default };
